import {storeOrderItems, StoreOrderItems} from "./order-items/StoreOrderItemsComponent";
import {
    completingOrderOverlay,
    CompletingOrderOverlay
} from "./completing-order-overlay/CompletingOrderOverlayComponent";

export default function(parentDir: string) {
    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.store.common.components", [])
                  .component(StoreOrderItems, storeOrderItems(rootDir))
                  .component(CompletingOrderOverlay, completingOrderOverlay(rootDir))
                  .name;
}
